import React from "react";
import PropTypes from "prop-types";
import SpecialCollectionCard from "@modules/SpecialCollections/SpecialCollectionCard/SpecialCollectionCard";
import SpecialCollectionListEntry from "@modules/SpecialCollections/SpecialCollectionListEntry";
import { LiteratureSearchResultsGrid } from "@modules/Literature/LiteratureSearchResultsGrid";
import { LiteratureSearchResultsList } from "@modules/Literature/LiteratureSearchResultsList";

// Wrapper to adapt react-searchkit props to SpecialCollectionCard props
const SpecialCollectionResultItem = ({ result }) => {
  return <SpecialCollectionCard data={result} />;
};

SpecialCollectionResultItem.propTypes = {
  result: PropTypes.object.isRequired,
};

// Wrapper for list view
const SpecialCollectionListItem = ({ result }) => {
  return <SpecialCollectionListEntry metadata={result.metadata} />;
};

SpecialCollectionListItem.propTypes = {
  result: PropTypes.object.isRequired,
};

export const ThesisSearchOverridesMap = {
  "ResultsList.item": SpecialCollectionListItem,
  "ResultsGrid.item": SpecialCollectionResultItem,
  ResultsList: LiteratureSearchResultsList,
  ResultsGrid: LiteratureSearchResultsGrid,
};
